import { isSafariBrowser } from '@/lib/utils'
import { featureFlagKeys } from '@/utils/data/featureFlags'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { useMemo } from 'react'

type PayPalExpressCheckout = {
  type: 'paypal_express_checkout'
  handlerKey: 'paypal'
  buttonId: 'paypal-button'
  label: 'PayPal'
}

type GooglePay = {
  type: 'google_pay'
  handlerKey: 'google-pay'
  buttonId: 'gpay-button'
  label: 'Google Pay'
}

type ApplePay = {
  type: 'apple_pay'
  handlerKey: 'apple-pay'
  buttonId: 'apple-pay-button'
  label: 'Apple Pay'
}

export type PaymentMethod = PayPalExpressCheckout | GooglePay | ApplePay

export const useExtraCheckoutMethods = () => {
  const isPayPayExpressEnabled = useFeatureFlagEnabled(featureFlagKeys.payPalExpressCheckout)
  const isGooglePayEnabled = useFeatureFlagEnabled(featureFlagKeys.googlePay)
  const isApplePayEnabled = useFeatureFlagEnabled(featureFlagKeys.applePay)

  const paymentMethods: PaymentMethod[] = [
    {
      type: 'paypal_express_checkout',
      handlerKey: 'paypal',
      buttonId: 'paypal-button',
      label: 'PayPal',
    },
    {
      type: 'google_pay',
      handlerKey: 'google-pay',
      buttonId: 'gpay-button',
      label: 'Google Pay',
    },
    {
      type: 'apple_pay',
      handlerKey: 'apple-pay',
      buttonId: 'apple-pay-button',
      label: 'Apple Pay',
    },
  ]

  const enabledPaymentMethods = useMemo(() => {
    let pMethods = paymentMethods
    if (!isPayPayExpressEnabled) {
      pMethods = pMethods.filter((method) => method.type !== 'paypal_express_checkout')
    }
    if (!isSafariBrowser() || !isApplePayEnabled) {
      pMethods = pMethods.filter((method) => method.type !== 'apple_pay')
    }
    if (!isGooglePayEnabled) {
      pMethods = pMethods.filter((method) => method.type !== 'google_pay')
    }
    return pMethods
  }, [isPayPayExpressEnabled, isApplePayEnabled, isGooglePayEnabled])
  return {
    paymentMethods: enabledPaymentMethods,
  }
}
